/* eslint-disable no-undef */
export const VdpFeatures = {
  props: ['featuresInitial'],
  data(){
    return {
      features: {
        categories: [],
      },
      content: [],
      selected: 0,
    }
  },
  created(){
    this.features = this.featuresInitial;
    this.content = this.features.categories[this.selected].features;
  },
  methods:{
    selectOne(i){
      this.selected = i;
      this.content = this.features.categories[i].features;
    },
  },
}
